<template>
  <button
    class="underline text-lg"
    @click="setPopupTitle(locationTitle)"
  >
    View on Map
  </button>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapMutations } = createNamespacedHelpers('map')

export default {
  props: {
    locationTitle: { type: String, default: null },
  },
  methods: {
    ...mapMutations(['setPopupTitle']),
  },
}
</script>
